window.ttx = window.ttx || {};
ttx.menu = ttx.menu || {};

/**
 * 菜单权限校验：侧边栏菜单点击时，调用后端判断当前用户是否有权访问该菜单。
 * 菜单标识复用前端侧边栏的 portal.billno / route。
 *
 * 使用方式：
 *   ttx.menu.checkPermission({ billno: 'inventory-order' }, function (res) {
 *       if (!res.hasPermission) { /* 无权限提示 *\/ }
 *   });
 *   ttx.menu.checkPermission({ route: '/home' }, cb);
 *
 * @param {Object} options - { billno?: string, route?: string, url?: string }
 * @param {Function} [callback] - 回调，参数 { hasPermission: boolean }
 * @returns {XMLHttpRequest}
 */
ttx.menu.checkPermission = function (options, callback) {
    options = options || {};
    return ttx.ajax.xhrUtil({
        url: '/api/menu/check-permission',
        method: 'POST',
        data: {
            billno: options.billno,
            route: options.route,
            url: options.url,
        },
        showErrorToast: false,
        success: function (res) {
            const hasPermission = !!(res && res.data && res.data.hasPermission);
            if (typeof callback === 'function') callback({ hasPermission });
        },
        error: function () {
            // 请求失败默认放行，避免网络/后端异常阻断菜单打开
            if (typeof callback === 'function') callback({ hasPermission: true });
        },
    });
};
